import './skeleton.scss';

const GetCount = (count) => {
    return Array.from({ length: count }, (_, index) => {
        return { id: index }; // Customize the object structure as needed
    });
};

export const Wkit_template_Skeleton = ({ count = 6 }) => {
    return (
        <div className="wkit-skeleton-main-wrap wkit-skeleton-row">
            {
                Object.values(GetCount(count)).map((data, index) => {
                    return (
                        <div className="wkit-skeleton-boxed" key={index}>
                            <div className="wkit-skeleton-inner-boxed ">
                                <ul>
                                    <li><div className="wkit-small-img-box"></div></li>
                                    <li><div className="wkit-small-img-box"></div></li>
                                    <li><div className="wkit-small-img-box"></div></li>
                                </ul>
                                <div className="wkit-template-bg">
                                    <div className="wkit-skeleton-square"></div>
                                </div>
                                <div className="wkit-title-meta-content">
                                    <div className="template-page-kit-title">
                                        <div className="wkit-skeleton-line"></div>
                                    </div>
                                    <div className="wkit-select">
                                        <div className="wkit-skeleton-line"></div>
                                    </div>
                                </div>
                                <div className="wkit-title-meta-content">
                                    <div className="wkit-action-inner">
                                        <div className="wkit-skeleton-line"></div>
                                    </div>
                                    <div >
                                        <div className="wkit-img-border-rounded"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
}